import React from 'react';
import { MdWarning as WarningIcon } from 'react-icons/md';

const EditCurrencyCodeAlertContent = () => (
  <div>
    <div><WarningIcon /> Warning!</div>
    <div>
      Updating a Currency Code related to a Country with BSM enabled Company Codes
      could have negative impacts to any existing balances.
    </div>
    <div>Please ensure there are no existing BSM balances prior to changing a Currency Code.</div>
  </div>
);

export default EditCurrencyCodeAlertContent;
